import { Pipe, PipeTransform } from '@angular/core';
import { RoutesService } from '@shared/services/routes/route.service';
import { INews } from '@collections/news/interfaces/news.interface';
import { ICompany } from '@collections/companies/interfaces/company.interface';
@Pipe({
    name: 'getNewsUrl',
    standalone: true
})
export class GetNewsUrlPipe implements PipeTransform {

  constructor(private routesService: RoutesService) {

  }

  transform(news: INews, company?: ICompany, absolute=false): any {
    const _company = company || news.company || null;
    return this.routesService.getNewsUrl(news.slug, _company, absolute);
  }

}
